<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                  ><img src="@assets/images/logo-dark.png" alt="" height="70"
                /></span>
              </a>
              <p v-if="agencies.length < 2" class="text-muted mb-4 mt-3">{{ textLoading }}</p>
              <div v-if="agencies.length > 1">

                <form class="mt-3" @submit.prevent="formSubmit">
                  <div class="form-group mb-3 text-left">
                    <label for="example-select">AFP Select <span class="text-danger">*</span></label>
                    <b-form-select v-model="cmbSelected" :options="agencies" value-field="id" text-field="name"></b-form-select>
                  </div>
                  <div class="form-group text-left row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-primary">Continue</button>
                    </div>
                    <div class="col-6 text-right">
                      <button type="button" class="btn btn-secondary" @click="logout">Logout</button>
                    </div>
                  </div>
                </form>

              </div>
            </div>

          </div>
          <!-- end card-body -->
        </div>

        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from '@layouts/auth'
import appConfig from '@src/app.config'
import store from '@state/store'
import axios from 'axios'
import { authMethods } from '@state/helpers'
var qs = require('qs')

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      textLoading: 'Loading user AFP...',
      agencies: [],
      cmbSelected: '',
      selectedAgency: ''
    }
  },
  created: function () {
    this.loadAgencies()
  },
  methods: {
    ...authMethods,
    loadAgencies() {
      return axios
      .get(appConfig.apiUrl + 'agency/user',
      { headers: { 'Authorization': `Bearer ${store.state.auth.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.agencies = response.data
        this.agenciesProcessor()
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    agenciesProcessor() {     
      if(this.agencies.length === 0) {
        this.textLoading = 'No agency avaible.'
      }
      else if (this.agencies.length === 1) {
        this.selectedAgency = this.agencies[0]
        this.setSelectedAgency()
      }
    },
    setSelectedAgency() {
      return axios
      .post(appConfig.apiUrl + 'user/login-agency',
      qs.stringify({
        agency: this.selectedAgency
      }),
      { headers: { 'Authorization': `Bearer ${store.state.auth.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.setUser(response.data)
        this.setAgency(this.selectedAgency)
        if (this.selectedAgency.id === 'a170a1c4-71a8-eb11-beba-402343f8b2f6') {
          this.$router.push({ name: 'self-cv' })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      })
    },
    logout () {
      this.$router.push({ name: 'logout'})
    },
    formSubmit () {
      if(this.cmbSelected.length === 0)
      {
        this.$notify({group: 'alert', type: 'error', title: 'Error', text: 'Please, select an agency.'});
        return false;
      }

      this.selectedAgency = this.filterAgency()

      this.setSelectedAgency()
    },
    filterAgency () {
      return this.agencies.filter(c => c.id.toLowerCase().indexOf(this.cmbSelected) > -1)[0];
    }
  }
}
</script>

<style lang="scss" module></style>
